import { render, staticRenderFns } from "./ui-html-editor.vue?vue&type=template&id=60b47338"
import script from "./ui-html-editor.vue?vue&type=script&lang=ts"
export * from "./ui-html-editor.vue?vue&type=script&lang=ts"
import style0 from "./ui-html-editor.vue?vue&type=style&index=0&id=60b47338&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports